import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { authLink, errorLink } from './authLink';

// HTTP Link
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL || 'http://localhost:5000/graphql',
});

// Cache configuration
const cache = new InMemoryCache({
  typePolicies: {
    User: {
      fields: {
        profile: {
          merge: true, // Merge nested objects
        },
        membershipDetails: {
          merge: true,
        },
      },
    },
    Content: {
      fields: {
        comments: {
          merge: false, // Replace array completely
        },
        tags: {
          merge: false,
        },
        metadata: {
          merge: true,
        },
      },
    },
    Gallery: {
      fields: {
        images: {
          merge: false,
        },
        tags: {
          merge: false,
        },
        metadata: {
          merge: true,
        },
      },
    },
    Query: {
      fields: {
        contents: {
          keyArgs: ['status', 'visibility', 'categoryId', 'authorId', 'search'],
          // offset === 0 → sostituisce (caricamento/refetch dall'inizio): evita
          // duplicati con fetchPolicy cache-and-network. offset > 0 → posiziona
          // gli elementi all'offset corretto (paginazione, senza accodare ciecamente).
          merge(existing = [], incoming, { args }) {
            const offset = (args && args.offset) || 0;
            if (offset === 0) return incoming;
            const merged = existing ? existing.slice(0) : [];
            for (let i = 0; i < incoming.length; i++) {
              merged[offset + i] = incoming[i];
            }
            return merged;
          },
        },
        galleries: {
          keyArgs: ['status', 'visibility', 'category', 'authorId'],
          merge(existing = [], incoming, { args }) {
            const offset = (args && args.offset) || 0;
            if (offset === 0) return incoming;
            const merged = existing ? existing.slice(0) : [];
            for (let i = 0; i < incoming.length; i++) {
              merged[offset + i] = incoming[i];
            }
            return merged;
          },
        },
      },
    },
  },
});

// Create Apollo Client
const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});

export default client;
